module.exports = __webpack_public_path__ + "static/media/signup-success-banner.43d71128.png";